import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { LoadingComponent } from "@digi-america/shared";
import { UtcToLocalTimePipe } from '../../pipes/utc-to-local.pipe';
import { DealDeskService } from '../../services/deal-desk.service';
import { ResponseDealDeskListItem } from '../../types/dai-server/deal-desk/deal-desk-responses';
import { DealDeskStatus, dealDeskStatusLabel, normalizeDealDeskStatus } from '../../types/dai-server/deal-desk/enums';
import { SessionService } from '../../services/session.service';

@Component({
  selector: 'app-deal-desk-search',
  imports: [LoadingComponent, FormsModule, RouterLink, CommonModule, UtcToLocalTimePipe],
  templateUrl: './deal-desk-search.component.html',
  styleUrl: './deal-desk-search.component.scss',
  standalone: true
})
export class DealDeskSearchComponent implements OnInit {
  dealDesks?: ResponseDealDeskListItem[];

  searchText: string = "";

  constructor(private _dealDesks: DealDeskService, private session: SessionService) { }

  ngOnInit(): void {
    this._dealDesks.getDealDesks().subscribe(dealDesks => {
      this.dealDesks = dealDesks.sort((a, b) => {
        return b.createdAt.localeCompare(a.createdAt);
      });
    });
  }

  canCreate(): boolean {
    return this.session.hasPermission("dealdesk:create");
  }

  statusLabel(status: string | null): string {
    return dealDeskStatusLabel(status);
  }

  statusClass(status: string | null): string {
    switch (normalizeDealDeskStatus(status)) {
      case DealDeskStatus.approved:
        return "bg-success";
      case DealDeskStatus.approvedWithChanges:
        return "bg-info";
      case DealDeskStatus.rejected:
        return "bg-danger";
      case DealDeskStatus.moreInfoRequested:
        return "bg-warning text-dark";
      default:
        return "bg-secondary";
    }
  }

  getFilteredDealDesks(): ResponseDealDeskListItem[] {
    const text = this.searchText.toLowerCase();
    return this.dealDesks?.filter(d => {
      return (d.customerName ?? "").toLowerCase().indexOf(text) !== -1 ||
        (d.creatorName ?? "").toLowerCase().indexOf(text) !== -1 ||
        (d.procurementStage ?? "").toLowerCase().indexOf(text) !== -1 ||
        dealDeskStatusLabel(d.status).toLowerCase().indexOf(text) !== -1;
    }) ?? [];
  }
}
